import { makeStyles } from '@material-ui/core/styles';
import Configuration from '../../components/app_common/register_form/configuration';

export const FORM_FIELDS_COLOR = '#DEDEDE';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    backgroundImage: `url(${Configuration.backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light'
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: FORM_FIELDS_COLOR,
  },
  paper: {
    width: '45vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem 2rem',
    minHeight: '75vh',
    borderRadius: '24px',
    border: '3px solid #2E3546',
    background: 'rgba(0, 0, 0, 0.2)',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  img_logo: {
    marginBottom: 13,
    height: 90,
    width: 100,
  },
}));

export default useStyles;
